import { StateService } from '@supoui/core/state-services/state.service';
import { SupplierInvoice } from '@supoui/shared/model/supplier-invoice';
import { Observable } from 'rxjs';

export class SupplierInvoiceStateService extends StateService<SupplierInvoice[]> {
  public sendSupplierInvoices(obj: SupplierInvoice[]) {
    this.sendModel(obj);
  }

  public getSupplierInvoices(): Observable<SupplierInvoice[]> {
    return this.getModel();
  }
}
